import { ReactNode, useContext, useEffect, useState } from "react";

import { LocationContext } from "../../utils/location/LocationProvider";
import { checkOnlineStatus } from "../../utils/os.utils";
import OfflineModal from "../offlinePage/OfflineModal";

const OfflinePageWrapper = ({ children }: { children: ReactNode }): JSX.Element => {
    const [isOnline, setIsOnline] = useState(true);
    const { location } = useContext(LocationContext);

    useEffect(() => {
        const fetchOnlineStatus = async () => {
            const onlineStatus = await checkOnlineStatus();
            setIsOnline(onlineStatus);
        };
        fetchOnlineStatus();
    }, [location]);
    const handleReload = async () => {
        const onlineStatus = await checkOnlineStatus();
        setIsOnline(onlineStatus);
    };

    return (
        <>
            {!isOnline && <OfflineModal handleReload={handleReload} isOnline={isOnline} />}
            {children}
        </>
    );
};

export default OfflinePageWrapper;
